export default "__VITE_ASSET__HFnjJDCDlZD6uFPXE2$ebQ__"